import type { ViewerCamera } from "@geosoft/viewer-sdk";

/** OrbitControls default / corrupted readback before the first real fly. */
export const NULL_ISLAND_LON_LAT_EPS_DEG = 0.01;

export function isPlaceholderCamera(
  camera: ViewerCamera | null | undefined,
): boolean {
  if (!camera?.lonLat) return true;
  const [lon, lat] = camera.lonLat;
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) return true;
  return (
    Math.abs(lon) < NULL_ISLAND_LON_LAT_EPS_DEG &&
    Math.abs(lat) < NULL_ISLAND_LON_LAT_EPS_DEG
  );
}

export function isNullIslandLonLat(lon: number, lat: number): boolean {
  return (
    Math.abs(lon) < NULL_ISLAND_LON_LAT_EPS_DEG &&
    Math.abs(lat) < NULL_ISLAND_LON_LAT_EPS_DEG
  );
}
